import React from 'react'

class Affix extends React.Component {
  constructor () {
    super()
    this.state = {
      affix: false
    }
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll.bind(this))
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll.bind(this))
  }

  handleScroll () {
    const affix = this.state.affix
    const offset = this.props.offset
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

    if (!affix && scrollTop >= offset) {
      this.setState({
        affix: true
      })
    }

    if (affix && scrollTop < offset) {
      this.setState({
        affix: false
      })
    }
  };

  render () {
    const affix = this.state.affix ? 'affix' : ''
    const { className, ...props } = this.props

    return (
      <div {...props} className={`${className || ''} ${affix}`}>
        {this.props.children}
      </div>
    )
  }
}

Affix.defaultProps = {
  offset: 100
}

export default Affix
